export default String.raw`
{% assign type = include -%}

{% if settings.grapicalVariantsPresentation != 'Variants_No' -%}
	{% comment %}
		<!-- This is a popup dialog for selecting graphical variants of a product. It includes a list of variants with images or colors. -->
	{% endcomment %}

	<dialog tabindex="-1" class="dialog graphical-variant-popup graphical-variant-popup-js" aria-labelledby="graphical-variant-popup-title">
		<div class="dialog__header">
			<h3 class="dialog__header-title" id="graphical-variant-popup-title">{{translations.ChooseVariant}}</h3>
			<form method="dialog">
				<button class="dialog__close close-js" aria-label="{{ translations.Close }}">
					<svg aria-hidden="true" height="24" width="24">
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
					</svg>
				</button>
			</form>
		</div>
		<div class="dialog__content">
			<p>{{firstLevelName}}: <span class="graphical-variant-name-js">{{firstLevelValue}}</span></p>
			<div class="chips-container" role="radiogroup" aria-label="{{translations.ChooseVariant}}">
				{% if type == 'polyvalent' -%}
					<div class="graphical-variants values attributes-js">
						{% for value in attribute.Values -%}
							<div class="graphical-variant graphical-variant-js">
								{% if settings.grapicalVariantsPresentation == 'Variants_Colors' -%}
									{% assign anyColor = false -%}
									{% for value in attribute.Values -%}
										{% for color in colorVariants -%}
											{% assign colorArr = color | Split: '||' -%}

											{%comment %} <!-- Case-insensitive comparison --> {% endcomment -%}
											{% assign valueDowncase = value.Value | Downcase -%}
											{% assign colorDowncase = colorArr[0] | Downcase -%}
											
											{% if colorDowncase == valueDowncase -%}
												{% assign anyColor = true -%}
												{% break -%}
											{% endif -%}
										{% endfor -%}
									{% endfor -%}
								
									{% assign colorHex = '#FFFFFF' -%}
									{% for color in colorVariants -%}
										{% assign colorArr = color | Split: '||' -%}

										{%comment %} <!-- Case-insensitive comparison --> {% endcomment -%}
										{% assign valueDowncase = value.Value | Downcase -%}
										{% assign colorDowncase = colorArr[0] | Downcase -%}

										{% if colorDowncase == valueDowncase -%}
											{% assign colorHex = colorArr[1] -%}
											{% break -%}
										{% endif -%}
									{% endfor -%}

									{% comment %} <!-- Color representation --> {% endcomment %}
									<label tabindex="0" class="chip {% if anyColor -%} chip--color {% else -%} chip--default {% endif -%}">
										<input tabindex="-1" type="radio" name="attributeId-cloned" value="{{ value.ValueId }}" {% if value.ValueId == selectedAttributeId -%} checked {% endif -%} data-variant="{{ value.Value }}">
										{% if anyColor -%}
											<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
												{% if colorHex == 'multicolor' %}
													<foreignObject x="4" y="4" width="32" height="32">
														<div xmlns="http://www.w3.org/1999/xhtml" class="multicolor"></div>
													</foreignObject>
												{% else %}
													<circle cx="20" cy="20" r="16" fill="{{ colorHex }}" {% if colorHex == '#FFFFFF' %} stroke="black" stroke-width="0.25"{% endif %}/>
												{% endif %}
											</svg>
										{% else -%}
											{{value.Value}}
										{% endif -%}
									</label>
								{% else -%}
									{% comment %} <!-- Normal chip --> {% endcomment %}
									<label tabindex="0" class="chip chip--default">
										<input tabindex="-1" type="radio" name="attributeId-cloned" value="{{ value.ValueId }}" {% if value.ValueId == selectedAttributeId -%} checked {% endif -%} data-variant="{{ value.Value }}">
										{{value.Value}}
									</label>
								{% endif -%}
							</div>
						{% endfor -%}
					</div>
				{% else -%}
					{% for firstLevelSupply in supplies -%}
						{% comment -%}
							<!-- Recursive get the first available child product (for image rendering on the first level) -->
							<!-- Returns: foundProduct and dataKeys -->
						{% endcomment -%}

						{% include 'partials/product/find-variant-product.html' with currentSupply: firstLevelSupply, depth: 1, maxDepth: levelsQuantity -%}

						{% assign noSupplyProductOnControlledStock = false -%}
						{% if supplyStockLevel.QuantityControl == true and supplyStockLevel.Value == 0 -%}
							{% assign noSupplyProductOnControlledStock = true -%}
						{% else -%}
							{% assign noSupplyProductOnControlledStock = false -%}
						{% endif -%}

						<div class="graphical-variant graphical-variant-js value {% if firstLevelSupply.ValueId == key -%} active-js {% endif -%} parent-container-reload-js prevent-instant-reload-js {% if levelsQuantity != 1 %} not-last-lvl-js {% else -%} child-js child-reload-js change-parent-js {% endif -%} {% if noSupplyProductOnControlledStock or foundProduct.Availability.Status == 3 -%} unavailable {% endif -%} {% if foundProduct.AskForPrice or noSupplyProductOnControlledStock or foundProduct.Availability.Status == 3 -%} ask-for-price-child-js {% endif -%} {% if foundProduct.AttributesEditable[0] or foundProduct.AttributesPolyvalent[0] -%} with-attributes {% endif -%}" data-url="{{ url }}?keys={{ dataKeys }}{% if unitId != null -%}&unit={{ unitId }}{% endif -%}" {% if levelsQuantity == 1 %} data-child-index="{{ forloop.index0 }}" data-supply-id="{{ firstLevelSupply.SupplyId }}" data-img="http:{{ page.BaseHref }}img/large/{{ foundProduct.ImageId }}/.jpg" data-code="{{ foundProduct.Code }}" data-weight="{{ foundProduct.Weight }}" data-netweight="{{ foundProduct.NetWeight}}" {% endif -%}>
							{% if settings.grapicalVariantsPresentation == 'Variants_Colors' -%}
								{% assign anyColor = false -%}
								{% for firstLevelSupply in supplies -%}
									{% for color in colorVariants -%}
										{% assign colorArr = color | Split: '||' -%}

										{%comment %} <!-- Case-insensitive comparison --> {% endcomment -%}
										{% assign valueDowncase = firstLevelSupply.Value | Downcase -%}
										{% assign colorDowncase = colorArr[0] | Downcase -%}
										
										{% if colorDowncase == valueDowncase -%}
											{% assign anyColor = true -%}
											{% break -%}
										{% endif -%}
									{% endfor -%}
								{% endfor -%}

								{% assign colorHex = '#FFFFFF' -%}
								{% for color in colorVariants %}
									{% assign colorArr = color | Split: '||' -%}

									{%comment %} <!-- Case-insensitive comparison --> {% endcomment -%}
									{% assign valueDowncase = firstLevelSupply.Value | Downcase -%}
									{% assign colorDowncase = colorArr[0] | Downcase -%}

									{% if colorDowncase == valueDowncase -%}
										{% assign colorHex = colorArr[1] -%}
										{% break -%}
									{% endif -%}
								{% endfor -%}

								{% comment %} <!-- Color representation --> {% endcomment %}
								<label tabindex="0" class="chip {% if anyColor -%} chip--color {% else -%} chip--default {% endif -%}">
									<input tabindex="-1" type="radio" name="graphical-variant-popup" value="{{firstLevelSupply.ValueId}}" {% if firstLevelSupply.ValueId == key -%} checked {% endif -%} data-variant="{{firstLevelSupply.Value}}">
									{% if anyColor -%}
										<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
											{% if colorHex == 'multicolor' %}
												<foreignObject x="4" y="4" width="32" height="32">
													<div xmlns="http://www.w3.org/1999/xhtml" class="multicolor"></div>
												</foreignObject>
											{% else %}
												<circle cx="20" cy="20" r="16" fill="{{ colorHex }}" {% if colorHex == '#FFFFFF' %} stroke="black" stroke-width="0.25"{% endif %}/>
											{% endif %}
										</svg>
									{% else -%}
										{{value.Value}}
									{% endif -%}
								</label>
							{% elseif settings.grapicalVariantsPresentation == 'Variants_Thumbnails' -%}
								{% comment %} <!-- Thumbnail representation --> {% endcomment %}
								<label tabindex="0" class="chip chip--thumbnail">
									<input tabindex="-1" type="radio" name="graphical-variant-popup" value="{{ firstLevelSupply.ValueId }}" {% if firstLevelSupply.ValueId == key -%} checked {% endif -%} data-variant="{{firstLevelSupply.Value}}">
										{% if firstLevelSupply.ValueId == key and activeProduct.Image -%}
											{{activeProduct | Img }}
										{% elseif foundProduct.Image -%}
											{{ foundProduct | Img }}
										{% else -%}
											<img width="52" height="52" src="css/img/img-placeholder.jpg" alt="{{translations.DefaultImage}}"/>
										{% endif -%}
								</label>
							{% elseif settings.grapicalVariantsPresentation == 'Variants_DropDownList' -%}
								{% comment %} <!-- Normal chip --> {% endcomment %}
								<label tabindex="0" class="chip chip--default">
									<input tabindex="-1" type="radio" name="graphical-variant-popup" value="{{ firstLevelSupply.ValueId }}" {% if firstLevelSupply.ValueId == key -%} checked {% endif -%} data-variant="{{firstLevelSupply.Value}}">
									{{firstLevelSupply.Value}}
								</label>
							{% endif -%}
						</div>
					{% endfor -%}
				{% endif -%}
			</div>
		</div>
		<div class="dialog__actions">
			<form method="dialog">
				<button class="primary-action-button choose-graphical-variant-js close-js {% if type == 'polyvalent' %} polyvalent-js {% endif %}" aria-label="{{ translations.Choose }}">
					<span>{{translations.Choose}}</span>
				</button>
			</form>
		</div>
	</dialog>
{% endif -%}
`